var _path, _path2, _path3, _path4, _path5, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 136,
    viewBox: "0 0 153 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.1252 95.5052V132.481C61.1252 135.85 65.433 137.286 67.4526 134.589L85.5147 110.512L91.0206 107.691L150.637 23.3983L151.746 16.8438L142.06 22.1966L61.1055 92.4728L61.1252 95.5052Z",
    fill: "#1A9D64"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M148.134 16.2804C147.975 16.3439 35.0937 73.0193 34.9404 73.0961C32.4787 74.3268 32.3273 77.7893 34.6692 79.2346L61.1222 95.515L151.743 16.8536C150.822 16.0554 149.499 15.7146 148.134 16.2804Z",
    fill: "#0FBC71"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M151.867 17.0163C151.816 16.9668 151.8 16.8902 151.746 16.8438L151.058 17.8188L85.5146 110.512L126.078 135.475C128.191 136.773 130.925 135.535 131.376 133.13L152.943 20.1637C153.172 18.9714 152.689 17.8166 151.867 17.0163Z",
    fill: "#0FBC71"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 49C20.7 46.2 20.5 30 22 30C23.5 30 23.016 45.1256 24.5 47.5C27 51.5 37.5 51.5 37.5 53.5C37.5 55.5 25.857 54.8576 24 59.5C22 64.5 24 88 22 88C20 88 21.8 66.2201 19 59.5C16.5 53.5 5 55.5 5 53.5C5 51.5 14.3 51.8 17.5 49Z",
    fill: "#FFC12E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7692 8.51724C91.2462 7.26207 91.1538 0 91.8462 0C92.5385 0 92.3151 6.78044 93 7.84483C94.1538 9.63793 99 9.63793 99 10.5345C99 11.431 93.6263 11.1431 92.7692 13.2241C91.8462 15.4655 92.7692 26 91.8462 26C90.9231 26 91.7539 16.2366 90.4615 13.2241C89.3077 10.5345 84 11.431 84 10.5345C84 9.63793 88.2923 9.77241 89.7692 8.51724Z",
    fill: "#FFC12E"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 65.5,
    cy: 35.5,
    r: 2.5,
    fill: "#FFC12E"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 109,
    r: 4,
    fill: "#FFC12E"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 30,
    r: 4,
    fill: "#FFC12E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/successIcon.86b4d600469fe6e0d09c88bdce560bda.svg";
export { ForwardRef as ReactComponent };